import { jsx as l } from "react/jsx-runtime";
import "@material-ui/core/Accordion";
import "@material-ui/core/AccordionDetails";
import "@material-ui/core/AccordionSummary";
import "@material-ui/core/Badge";
import "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Collapse";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Fab";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Radio";
import { makeStyles as c } from "@material-ui/core/styles";
import "@material-ui/core/Switch";
import "@material-ui/core/Tab";
import "@material-ui/core/Tabs";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/AccountBalance";
import "@material-ui/icons/ArrowBack";
import "@material-ui/icons/ArrowBackIos";
import "@material-ui/icons/ArrowForwardIos";
import "@material-ui/icons/Close";
import "@material-ui/icons/CloudDownloadOutlined";
import "@material-ui/icons/CreditCard";
import "@material-ui/icons/DeleteOutlineOutlined";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Info";
import "@material-ui/icons/InfoOutlined";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/KeyboardArrowUp";
import "@material-ui/icons/Visibility";
import "@material-ui/lab/Alert";
import "@material-ui/lab/AlertTitle";
import "@material-ui/lab/Pagination";
const d = ({ iterations: t, overrideIterator: r }) => [...new Array(t)].map(() => r).join(" "), f = ({
  iterateValues: t = "0;1;1;0;",
  begin: r = 4,
  utterance: o = 4,
  duration: i = 10,
  color: e = "#000"
}) => {
  const a = `stop-color: ${e}; stop-opacity: 0`, m = [...new Array(100)];
  let p = "";
  return m.forEach((s, n) => {
    p += `<stop offset="${n}%" style="${a}">
                            <animate
                                attributeName="stop-opacity"
                                values="${t}"
                                begin="${r * 100 + n * o}ms"
                                dur="${i * 100}ms"
                                fill="freeze"
                                repeatCount="1000"
                            />
                        </stop>`;
  }), p;
}, L = ({
  size: t = 240,
  color: r = "#000",
  iterations: o = 1,
  duration: i = 10,
  begin: e = 0,
  utterance: a = 4,
  overrideIterator: m = "0;1;1;0;"
}) => {
  const p = d({ iterations: o, overrideIterator: m }), s = f({
    iterateValues: p,
    begin: e,
    utterance: a,
    duration: i,
    color: r
  });
  return {
    __html: `<svg id="propifyLoading" width="${t}" height="${t}" preserveAspectRatio="xMaxYMid meet" viewBox="0 0 444 401">
                    <defs>
                    <lineargradient id="propifyGradient" x1="0%" y1="0%" x2="0%" y2="100%" gradientUnits="userSpaceOnUse">
                        ${s}
                    </lineargradient>
                    </defs>
                    <g>
                    <clipPath id="clipPropifyLogo">
                        <path
                            style="fill: #03b1c9"
                            class="fakePropifyPath"
                            d="M222.98 325.75L443.12 297.8V174.8L335.01 87.49L222.98 195.86V325.75Z M331.09 0L111.96 57.07L0.98999 177.74L5.37 350.82L157.38 400.21V168.04L331.09 0Z"
                        />
                    </clipPath>
                    </g>
                    <path
                        clip-path="url(#clipPropifyLogo)"
                        class="fakePropifyPath"
                        fill="url(#propifyGradient)"
                        d="M222.98 325.75L443.12 297.8V174.8L335.01 87.49L222.98 195.86V325.75Z M331.09 0L111.96 57.07L0.98999 177.74L5.37 350.82L157.38 400.21V168.04L331.09 0Z"
                    />
                </svg>`
  };
}, y = (t) => /* @__PURE__ */ l("div", { dangerouslySetInnerHTML: L(t), ...t }), u = c(
  {
    loaderContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%"
    }
  },
  { name: "SectionLoader" }
), gt = ({
  testId: t,
  size: r = 60,
  className: o,
  color: i = "#ccc"
}) => {
  const e = u();
  return /* @__PURE__ */ l(
    y,
    {
      "data-testid": t,
      utterance: 5,
      begin: -10,
      duration: 30,
      size: r,
      className: `${o} ${e.loaderContainer}`,
      color: i
    }
  );
};
export {
  gt as SectionLoader,
  y as default
};
//# sourceMappingURL=Loader.js.map
